import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import CommentDataView from "./InquiryItemView";
import RadioButton from "../RadioButton";
import "../../styles/Activity.css";
import dateFormat, { masks } from "dateformat";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIRichTextEditor from "mui-rte";
import { stateToHTML } from "draft-js-export-html";
import ReactHtmlParser from "react-html-parser";
export function SaleInquiryDetailComponent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [getSubjectStatus, setSubjectStatus] = useState("Status details");
  const [showContent, setShowContent] = useState(true);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("param1");
  const status_param = searchParams.get("param2");
  const fromMail = searchParams.get("param3");
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [getRequestBy, setRequestBy] = useState();
  const [getRequestReason, setRequestReason] = useState();

  const [getBusinessType, setBusinessType] = useState();

  const [getShipper, setShipper] = useState();
  const [getShipperDetail, setShipperDetail] = useState("");
  const [getPor, setPor] = useState();
  const [getPol, setPol] = useState();
  const [getPod, setPod] = useState();
  const [getDel, setDel] = useState();
  const [getCommodityDetail, setCommodityDetail] = useState("");
  const [getCommodity, setCommodity] = useState();
  const [getContainerSize, setContainerSize] = useState();
  const [getContainerType, setContainerType] = useState();
  const [getDangerous, setDangerous] = useState("");
  const [getCMB, setCMB] = useState("");
  const [getDG, setDG] = useState("");
  const [qty, setQty] = useState("");
  const [weight, setWeight] = useState("");
  const [dimension, setDimension] = useState("");
  const [remark, setRemark] = useState("");
  const [getRemarkToCarrier, setRemarkToCarrier] = useState("");
  
  const [getFeedback, setFeedback] = useState(null);
  const [targetRate, setTargetRate] = useState("");
  const [getCarrier, setCarrier] = useState();
  const [getSale, setSale] = useState();
  const [getCopyTo, setCopyTo] = useState();
  const [getStatus, setStatus] = useState();
  const [subjectName, setSubjectName] = useState("");
  const [commentData, setCommentData] = useState([]);
  const [teuData, setTeuData] = useState([]);
  const [buttonMsg, setButtonMsg] = useState("");
  const [getStatusName, setStatusName] = useState();
  const [getStatusChange, setStatusChange] = useState();
  const [getStatusChangeName, setStatusChangeName] = useState();
  const [getStatusComment, setStatusComment] = useState("");
  const [getAttachment, setAttachment] = useState("");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [getExpectEtd, setExpectEtd] = useState("");
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [showButton, setShowButton] = useState(true);
  const [showRadio, setShowRadio] = useState(true);
  const [showTEU, setShowTEU] = useState(false);
  const [showDimension, setShowDimension] = useState(false);
  const [showComplete, setShowComplete] = useState(true);
  const [showErrorComment, setShowErrorComment] = useState("");
  const [getHSCODE, setHSCODE] = useState("");
  const [getPorName, setPorName] = useState("");
  const [getPodName, setPodName] = useState("");
  const [getPolName, setPolName] = useState("");
  const [getDelName, setDelName] = useState("");
  const [getPackageType, setPackageType] = useState("");
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();

  const [getDateFrom, setDateFrom] = useState();
  const [getDateTo, setDateTo] = useState();
  const [getMinDate, setMinDate] = useState(null);
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);

  useEffect(() => {
    //run when id Change value.
    if (id > 0) {
      try {
        fetch(api_path + "/TS_SALES_INQUIRY_BY_ID.php?param1=" + id)
          .then((res) => res.json())
          .then((res) => {
            const array = res;
            if (array.length > 0) {
              setShowContent(true);
              for (const i of array) {
                setRequestBy(i.USERNAME);
                if (i.REQUEST_STATUS == 1) {
                  setRequestReason("ไม่มีราคาในระบบ No rate in system");
                } else if (i.REQUEST_STATUS == 2) {
                  setRequestReason("มีราคาในระบบ แต่ต้องการต่อรองราคา");
                } else if (i.REQUEST_STATUS == 3) {
                  setRequestReason(
                    "ต้องการข้อมูลสายเรืออื่นเพิ่ม เพื่อการเปรียบเทียบราคา"
                  );
                }

                setStatusName(i.STATUS_NAME);
                setSubjectName(
                  "Inquiry ID=" + id + ", Status= " + i.STATUS_NAME
                );
                if (getUserRole == 3) {
                  //svp sales
                  if (i.STATUS_ID == 5 || i.STATUS_ID == 6) {
                    //Complete
                    setStatusChangeName("Complete");
                    setShowButton(false);
                    setShowRadio(false);
                    setShowComplete(false);
                    setSubjectStatus("Status details");
                  } else {
                    setSubjectStatus("Close Inquiry");
                    setShowRadio(false);
                    setShowComplete(false);
                    setStatusChange("6");
                    setStatusChangeName("Close");
                    setButtonMsg("Close");
                  }
                } else {
                  if (i.STATUS_ID == 1) {
                    //new
                    setShowRadio(false);
                    setShowComplete(false);
                    if (getUserRole == 4 || getUserRole == 7 || getUserRole == 9) {
                      //pricing and it
                      setSubjectStatus("Change status to Processing");
                      setButtonMsg("Processing");
                      setStatusChangeName("Processing");
                      setStatusChange(2);
                      setShowButton(true);
                    } else {
                      setShowButton(false);
                    }
                  } else if (i.STATUS_ID == 2) {
                    // Processing
                    setShowRadio(false);
                    setShowComplete(false);
                    if (getUserRole == 4 || getUserRole == 7 || getUserRole == 9) {
                      //pricing and it
                      setStatusChangeName("Done");
                      setSubjectStatus("Change status to Done");
                      setButtonMsg("Done");
                      setStatusChange(3);
                      setShowButton(true);
                    } else {
                      setShowButton(false);
                    }
                  } else if (i.STATUS_ID == 3) {
                    //done
                    setShowRadio(true);
                    setShowComplete(true);
                    //set default to complete
                    setStatusChange("5");
                    setStatusChangeName("Complete");
                    if (
                      getUserRole == 1 ||
                      getUserRole == 2 ||
                      getUserRole == 7
                    ) {
                      setShowButton(true);
                      setButtonMsg("Save status");
                    } else {
                      setSubjectStatus("Status details");
                      setShowButton(false);
                    }
                    if (getUserRole == 4 || getUserRole == 9) {
                      setShowRadio(false);
                      setShowComplete(false);
                    }
                  } else if (i.STATUS_ID == 4) {
                    //reject
                    if (
                      getUserRole == 1 ||
                      getUserRole == 2 ||
                      getUserRole == 7
                    ) {
                      //sales and it
                      setSubjectStatus("Status details");
                      setShowButton(false);
                      setShowComplete(false);
                      setShowRadio(false);
                    } else {
                      // pricing change status to done
                      // on processing again
                      setShowRadio(false);
                      setShowComplete(false);
                      if (getUserRole == 4 || getUserRole == 7 || getUserRole == 9) {
                        //pricing and it
                        setStatusChangeName("Done");
                        setSubjectStatus("Change status to Done");
                        setButtonMsg("Done");
                        setStatusChange(3);
                        setShowButton(true);
                      } else {
                        setShowButton(false);
                      }
                    }
                  } else if (i.STATUS_ID == 5) {
                    setStatusChangeName("Complete");
                    setShowButton(false);
                    setShowRadio(false);
                    setShowComplete(false);
                  } else if (i.STATUS_ID == 6) {
                    setStatusChangeName("Close");
                    setShowButton(false);
                    setShowRadio(false);
                    setShowComplete(false);
                  } else if (i.STATUS_ID == 0) {
                  } else {
                    setStatusChangeName("Processing");
                    setButtonMsg("Processing");
                    setStatusChange(2);
                  }
                } //end check role=3 (head sales)
                setDateFrom(dateFormat(i.ETD_FROM, "dd-mmm-yyyy"));
                setDateTo(dateFormat(i.ETD_TO, "dd-mmm-yyyy"));
                setBusinessType(i.Business_name);
                setShipper(i.Customer_name);
                setShipperDetail(i.SHIPPER_DETAIL);
                setPol(i.POL);
                setPod(i.POD);
                setPor(i.POR);
                setDel(i.DEL);
                setCommodity(i.COMMODITY);
                setCommodityDetail(i.COMMODITY_DETAIL);
                setHSCODE(i.HS_CODE);
                setQty(i.QUANTITY);
                setContainerSize(i.CONTAINER_SIZE);
                setDG(i.DG_CLASS);
                setDangerous(i.DANGEROUS);
                setCMB(i.CBM);
                setPackageType(i.PACKAGE_TYPE);
                setContainerType(i.CONTAINER_TYPE);
                setWeight(i.WEIGHT);
                setDimension(i.DIMENSION);
                setTargetRate(i.TARGET_RATE);
                setCarrier(i.CARRIER);
                setStatus(i.STATUS_ID);
                setSale(i.SALE_NAME);
                setCopyTo(i.SALESTO);
                setRemark(i.REMARK);
                setRemarkToCarrier(i.REMARK_TO_CARRIER)
                setAttachment(i.ATTACHMENT);
                if (
                  i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "SEA" ||
                  i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "REEFER" ||
                  i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "SOC" ||
                  i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "TANK"
                ) {
                  setShowTEU(true);
                  setShowDimension(false);
                  //setShowPackageType(false);
                } else {
                  setShowTEU(false);
                  setShowDimension(true);
                }
                //  if (i.BUSINESS_ID == "WH" || i.BUSINESS_ID == "LCL" || i.BUSINESS_ID == "BREAKBULK") {
                //   setShowDimension(true);
                //   setShowTEU(false);
                //   //setShowPackageType(false);
                //  }else{
                //   setShowDimension(false);
                //   setShowTEU(true);
                //  }
                //  if (i.BUSINESS_ID == "AIR" ){
                //   //setShowPackageType(true);
                //   setShowDimension(true);
                //   setShowTEU(false);
                //  } else {
                //   //setShowPackageType(false);
                //   setShowDimension(false);
                //   setShowTEU(true);
                // }
                if (i.POR_NAME == null) {
                  setPorName("-");
                } else {
                  setPorName("(" + i.POR_NAME + ")");
                }
                if (i.POD_NAME == null) {
                  setPodName("-");
                } else {
                  setPodName("(" + i.POD_NAME + ")");
                }
                if (i.POL_NAME == null) {
                  setPolName("-");
                } else {
                  setPolName("(" + i.POL_NAME + ")");
                }
                if (i.DEL_NAME == null) {
                  setDelName("-");
                } else {
                  setDelName("(" + i.DEL_NAME + ")");
                }
                setExpectEtd(i.EXPECT_ETD);
              }
            } else {
              setShowContent(false);
            }
            fetchItemData();
            fetchTeuData();
          });
      } catch (err) {
        console.error(err);
      }
    } else {
      setSubjectName("New Inquiry");
    }
  }, [id]);
  const handleCommentClick = () => {
    //console.log("comment..." + getStatusComment)
    if (id > 0) {
      if (
        getStatusComment === null ||
        getStatusComment === "<p><br></p>" ||
        getStatusComment === "<p>&nbsp;</p>"
      ) {
        swal("Please fill your comment.");
        setButtonDisabled(true);
      } else {
        var data = {
          USERID: getUserID,
          STATUS_ID: 0,
          STATUS_COMMENT: getStatusComment,
          FEEDBACK: getFeedback,
          INQUIRY_ID: id,
        };
        fetch(api_path + "/TS_SALES_INQUIRY_ITEM.php", {
          method: "POST",
          headers: {
            Accept: "application/form-data",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((result) => {
            if (result["status"] == "200") {
              //console.log("message..."+result["message"])
              swal(
                "Done.",
                "This inquiry change status by " + getUserID,
                "success",
                {
                  buttons: true,
                  timer: 5000,
                }
              ).then(function () {
                const url =
                  api_path +
                  "/SENDMAIL_INQUIRY_COMMENT.php?ITEM_ID=" +
                  result["message"] +
                  "&ROLE_ID=" +
                  getUserRole;
                axios
                  .get(url)
                  .then((response) => {
                    // handle success
                    setButtonDisabled(true);
                    console.log(response);
                  })
                  .catch((error) => {
                    setButtonDisabled(true);
                    // handle errors
                  });
                window.location = "./SaleInquiryDetail?param1=" + id;
              });
            } else {
              swal("Sorry", result["message"], "error", {
                buttons: true,
                timer: 5000,
              }).then(function () {
                setButtonDisabled(true);
              });
            }
          });
      }
    } else {
      swal("Please contact administrator.");
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    setButtonDisabled(false);
    if (getFeedback === null && getStatusChange == "5") {
      swal("Please select your feedback.");
      setButtonDisabled(true);
    } else if (
      getStatusComment === null ||
      getStatusComment === "<p><br></p>" ||
      getStatusComment === "<p>&nbsp;</p>"
    ) {
      swal("Please fill your information.");
      setButtonDisabled(true);
    } else {
      swal({
        title: "Are you sure?",
        text: "You want to change status to " + getStatusChangeName + " ?",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          if (id > 0) {
            var data = {
              USERID: getUserID,
              STATUS_ID: getStatusChange,
              STATUS_COMMENT: getStatusComment,
              FEEDBACK: getFeedback,
              INQUIRY_ID: id,
            };
          }
          fetch(api_path + "/TS_SALES_INQUIRY_ITEM.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              //console.log(result["status"]);
              //console.log(result["message"]);
              if (result["status"] == "200") {
                swal(
                  "Done.",
                  "This inquiry change status by " + getUserID,
                  "success",
                  {
                    buttons: true,
                    timer: 5000,
                  }
                ).then(function () {
                  const url =
                    api_path + "/SENDMAIL_INQUIRY_PROCESS.php?INQUIRY_ID=" + id;
                  axios
                    .get(url)
                    .then((response) => {
                      // handle success
                      setButtonDisabled(true);
                      console.log(response);
                    })
                    .catch((error) => {
                      setButtonDisabled(true);
                      // handle errors
                    });
                  window.location = "./SaleInquiryDetail?param1=" + id;
                });
              } else if (result["status"] == "202") {
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  window.location = "./SaleInquiryDetail?param1=" + id;
                  setButtonDisabled(true);
                });
              } else {
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  setButtonDisabled(true);
                });
              }
            });
          //}
        } else {
          setSubmitting(false);
          setButtonDisabled(true);
        }
      });
    }
  };

  const [checked, setChecked] = React.useState(true);

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };
  const showCostData = true;
  const fetchItemData = async () => {
    const response = await fetch(
      api_path + "/TS_SALES_INQUIRY_ITEM.php?id=" + id
    );
    const data = await response.json();
    setCommentData(data);
  };

  function DisplayCommentData(props) {
    if (props.commentData.length > 0) {
      return (
        <div className="">
          <div className="timeline-item-v2-component">
            {showCostData ? (
              <>
                {commentData.map((fdata) => {
                  return (
                    <CommentDataView
                      key={fdata.INQUIRY_ITEM_ID}
                      id={fdata.INQUIRY_ID}
                      STATUS_ID={fdata.STATUS_ID}
                      STATUS_NAME={fdata.INQUIRY_MASTER_EN}
                      USERID={fdata.USERNAME}
                      INSERT_DATE={fdata.INSERT_DATE}
                      COMMENT={fdata.COMMENT}
                      ATT1={fdata.ATT1}
                    />
                  );
                })}
              </>
            ) : (
              <p>You cannot see the data</p>
            )}
          </div>
        </div>
      );
    } else {
    }
  }
  const showTeuData = true;
  const fetchTeuData = async () => {
    const response = await fetch(
      api_path + "/TS_SALES_INQUIRY_TEU.php?id=" + id
    );
    const data = await response.json();
    setTeuData(data);
  };

  function DisplayTeuItem(props) {
    if (props.teuData.length > 0) {
      return (
        <table className="table">
          <thead>
            <tr>
              <th>SIZE</th>
              <th>TYPE</th>
              <th>QTY</th>
              <th>NOTE</th>
            </tr>
          </thead>
          {showTeuData ? (
            <>
              {teuData.map((fdata) => {
                return (
                  <tbody>
                    <tr key={fdata.INQUIRY_TEU_ID}>
                      <td>{fdata.CTNR_SIZE}</td>
                      <td>{fdata.CTNR_TYPE}</td>
                      <td>{fdata.CTNR_QTY}</td>
                      <td>{fdata.INQUIRY_TEU_NOTE}</td>
                    </tr>
                  </tbody>
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  const [radioStatus, setRadioStatus] = useState("Complete");
  const [radioResponse, setRadioResponse] = useState();
  const handleStatusRadioChange = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "Complete") {
      setStatusChange(5);
      setStatusChangeName("Complete");
      setShowRadio(true);
    } else if (event.target.value == "Reject") {
      setStatusChange(4);
      setStatusChangeName("Reject");
      setShowRadio(false);
    }
  };

  const isChecked = (value) => radioStatus === value;

  const handleResponseRadioChange = (event) => {
    setRadioResponse(event.target.value);
    if (event.target.value == "Positive") {
      setFeedback("Positive");
      setStatusChange(5);
    } else {
      setFeedback("Negative");
      setStatusChange(5);
    }
  };

  const isChecked2 = (value) => radioResponse === value;
  const handleAddButtonClick = React.useCallback((e) => {
    navigate({
      pathname: "/s-crm/SaleInquiry",
      search: "",
    });
  }, []);
  const [initialData, setInitialData] = useState("");
  let options = {
    entityStyleFn: (entity) => {
      const entityType = entity.get("type").toLowerCase();
      if (entityType === "image") {
        const data = entity.getData();
        return {
          element: "img",
          attributes: {
            src: data.src,
          },
          style: {
            // Put styles here...
          },
        };
      }
    },
  };
  const getHTMLData = (value) => {
    // let html = stateToHTML(value.getCurrentContent(), options);
    // console.log("value... "+html)
    stateToHTML(value.getCurrentContent());
    setInitialData(stateToHTML(value.getCurrentContent()));
    setStatusComment(stateToHTML(value.getCurrentContent()));
  };
  const getData = () => {
    console.log("Initial data ", initialData);
  };
  const myTheme = createTheme({
    overrides: {
      MUIRichTextEditor: {
        root: {
          backgroundColor: "#ebebeb",
        },
        container: {
          display: "flex",
          flexDirection: "column-reverse",
        },
        editor: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
        },
        toolbar: {
          borderTop: "1px solid gray",
          backgroundColor: "#ebebeb",
        },
        placeHolder: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
          width: "inherit",
          height: " 100px",
          maxHeight: "100px",
        },
        anchorLink: {
          color: "#333333",
          textDecoration: "underline",
        },
      },
    },
  });
  const splitedStr = getAttachment.split(",");

  var returnStr = "";
  for (var i = 0; i < splitedStr.length; i++) {
    returnStr +=
      '<p><a href="https://apps.sinologistics.co.th/api/uploads/sales_inquiry_local/' +
      splitedStr[i] +
      '" target="_blank">' +
      splitedStr[i] +
      "</a></p>";
  }
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}></Grid>
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid container spacing={2} className="BorderBox">
          <Grid
            item
            xs={12}
            sm={12}
            style={{ display: "flex" }}
            justify-content="flex-end"
          >
            <Button
              className="addBtn"
              type="button"
              variant="contained"
              color="primary"
              onClick={handleAddButtonClick}
            >
              View All Inquiry
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <label className="head2">{subjectName}</label>
            </Grid>
            {showContent === true ? (
              <div></div>
            ) : (
              <label className="head2">Not found data.</label>
            )}
            <Grid item xs={12} sm={12}>
              {/* <!---Left side--> */}
              {showContent && (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <label>REQUEST BY:</label>
                    <p className="data">{getRequestBy}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>REQUEST REASON:</label>
                    <p className="data">{getRequestReason}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>SALES IN CHARGE:</label>
                    <p className="data"> {getSale}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>CC TO:</label>
                    <p className="data"> {getCopyTo}</p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>Valid From</label>
                    <p className="data"> {getDateFrom}</p>
                    &nbsp; &nbsp;
                    <label>To</label>
                    <p className="data">{getDateTo}</p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    &nbsp;{" "}
                  </Grid>
                  <Grid item xs={12}>
                    <hr className="underline" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>POR:</label>
                    <p className="data">
                      {" "}
                      {getPor}&nbsp;{getPorName}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>POL:</label>
                    <p className="data">
                      {" "}
                      {getPol}&nbsp;{getPolName}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>POD:</label>

                    <p className="data">
                      {" "}
                      {getPod}&nbsp;{getPodName}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>DEL:</label>
                    <p className="data">
                      {" "}
                      {getDel}&nbsp;{getDelName}
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <hr className="underline" />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <label>SHIPPER NAME:</label>
                    <p className="data"> {getShipper}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>SHIPPER DETAIL:</label>
                    <p className="data"> {getShipperDetail}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label>COMMODITY:</label>
                    <p className="data"> {getCommodity}</p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>HS CODE:</label>
                    <p className="data"> {getHSCODE}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>COMMODITY DETAIL:</label>
                    <p className="data"> {getCommodityDetail}</p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label> DANGEROUS:</label>
                    <p className="data"> {getDangerous}</p>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label> DG CLASS/UN NO:</label>
                    <p className="data"> {getDG}</p>
                  </Grid>
                  <Grid item xs={12}>
                    <hr className="underline" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>BUSINESS TYPE:</label>
                    <p className="data"> {getBusinessType}</p>
                  </Grid>

                  {showTEU && (
                    <Grid item xs={12} sm={12}>
                      <DisplayTeuItem teuData={teuData} />
                    </Grid>
                  )}
                  {/* <Grid item xs={12} sm={6}>
                  <label>SIZE:</label>
                  <p className="data"> {getContainerSize}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <label>TYPE:</label>
                  <p className="data"> {getContainerType}</p>
                </Grid> */}
                  {showDimension && (
                    <Grid item xs={12} sm={6}>
                      <label>DIMENSION:</label>
                      <p className="data"> {dimension}</p>
                    </Grid>
                  )}
                  {showDimension && (
                    <Grid item xs={12} sm={6}>
                      <label>QTY:</label>
                      <p className="data"> {qty}</p>
                    </Grid>
                  )}
                  {showDimension && (
                    <Grid item xs={12} sm={6}>
                      <label>WEIGHT(kgs.):</label>
                      <p className="data"> {weight}</p>
                    </Grid>
                  )}
                  {showDimension && (
                    <Grid item xs={12} sm={6}>
                      <label>CBM:</label>
                      <p className="data"> {getCMB}</p>
                    </Grid>
                  )}
                  {showDimension && (
                    <Grid item xs={12} sm={6}>
                      <label>PACKAGE TYPE:</label>
                      <p className="data"> {getPackageType}</p>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <hr className="underline" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>CARRIER:</label>
                    <p className="data">{getCarrier}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    &nbsp;{" "}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>TARGET RATE:</label>
                    <p className="data">{targetRate}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>Expect ETD date / ETA:</label>
                    <p className="data">{getExpectEtd}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>REMARK TO PRICING:</label>
                    <p className="data"> {remark}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>REMARK TO CARRIER:</label>
                    <p className="data"> {getRemarkToCarrier}</p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <label>ATTACHMENT:</label>
                    <p className="data">
                      {/* <a href={`https://apps.sinologistics.co.th/api/uploads/inquiry_file/${returnStr}`}> */}
                      {ReactHtmlParser(returnStr)}
                      {/* </a> */}
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <hr className="underline" />
                  </Grid>
                </Grid>
              )}
              {/* <!---Left side--> */}
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            {showContent && (
              <Grid item xs={12} sm={12}>
                <label className="head2">{getSubjectStatus}</label>
              </Grid>
            )}
            {showContent && (
              <Grid item xs={12} sm={12}>
                {/* <!---Right side--> */}
                <TextField
                  name="StatusChange"
                  id="StatusChange"
                  value={getStatusChange}
                  inputProps={{ readOnly: true }}
                  onChange={(e) => setStatusChange(e.target.value)}
                  type="hidden"
                />
                <TextField
                  size="small"
                  name="StatusChangeName"
                  id="StatusChangeName"
                  value={getStatusChangeName}
                  inputProps={{ readOnly: true }}
                  onChange={(e) => setStatusChangeName(e.target.value)}
                  type="hidden"
                />
                {showComplete && (
                  <Grid item xs={12} sm={12}>
                    <label className="subj">Select Status:</label>
                    <RadioButton
                      id="Complete"
                      name="Complete"
                      value="Complete"
                      text="Complete"
                      onChange={handleStatusRadioChange}
                      checked={isChecked("Complete")}
                    />
                    <RadioButton
                      id="Reject"
                      name="Reject"
                      value="Reject"
                      text="Reject"
                      onChange={handleStatusRadioChange}
                      checked={isChecked("Reject")}
                    />
                  </Grid>
                )}
                {showRadio && (
                  <Grid item xs={12} sm={12}>
                    <label className="subj">Feedback:</label>
                    <RadioButton
                      id="Positive"
                      name="Positive"
                      value="Positive"
                      text="Positive"
                      onChange={handleResponseRadioChange}
                      checked={isChecked2("Positive")}
                    />
                    <RadioButton
                      id="Negative"
                      name="Negative"
                      value="Negative"
                      text="Negative"
                      onChange={handleResponseRadioChange}
                      checked={isChecked2("Negative")}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={12}>
                  <label className="subj">Please fill your information.</label>
                  <ThemeProvider theme={myTheme}>
                    <MUIRichTextEditor
                      label="Type something here..."
                      inlineToolbar={true}
                      controls={[
                        "title",
                        "bold",
                        "italic",
                        "underline",
                        "highlight",
                        "link",
                        "numberList",
                        "bulletList",
                        "quote",
                        "code",
                        "clear",
                        "undo",
                        "redo",
                      ]}
                      onChange={(value) => getHTMLData(value)}
                    />
                  </ThemeProvider>
                  {showErrorComment}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ display: "flex", padding: "10px 0 0 10px" }}
                  justify-content="flex-end"
                >
                  <Button
                    type="button"
                    variant="contained"
                    color="info"
                    onClick={handleCommentClick}
                  >
                    Add Comment
                  </Button>
                  &nbsp;
                  {showButton && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      isLoading={isSubmitting}
                      disabled={!isButtonDisabled}
                    >
                      {buttonMsg}
                    </Button>
                  )}
                </Grid>

                <Grid item xs={12} sm={12}>
                  <hr />
                  <DisplayCommentData commentData={commentData} />
                </Grid>

                {/* <!---Right side--> */}
              </Grid>
            )}
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
